<div class="counter" *ngIf="value && value > 0">{{ value }}</div>
